var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "panel",
      attrs: { "aria-labelledby": _vm.side + "-heading" },
    },
    [
      _c("div", { staticClass: "panel__head" }, [
        _c(
          "span",
          {
            staticClass: "role-badge",
            class: "role-badge--" + _vm.side,
            attrs: { "aria-hidden": "true" },
          },
          [_vm._v(_vm._s(_vm.badge))]
        ),
        _vm._v(" "),
        _c("h3", { attrs: { id: _vm.side + "-heading" } }, [
          _vm._v(_vm._s(_vm.heading)),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "hint" }, [_vm._v(_vm._s(_vm.hint))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "panel__filters" }, [
        _c("div", { staticClass: "field-group" }, [
          _c(
            "div",
            { staticClass: "field" },
            [
              _c("label", { attrs: { for: _vm.side + "-location" } }, [
                _vm._v("Monitoring location"),
              ]),
              _vm._v(" "),
              _vm.collisionNote
                ? _c("p", { staticClass: "field-note field-note--warn" }, [
                    _vm._v(_vm._s(_vm.collisionNote)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("v-autocomplete", {
                attrs: {
                  id: _vm.side + "-location",
                  value: _vm.filter.LocationId,
                  items: _vm.locations,
                  "item-text": "label",
                  "item-value": "id",
                  placeholder: "Any location",
                  clearable: "",
                  "hide-details": "",
                },
                on: {
                  input: function ($event) {
                    return _vm.set("LocationId", $event)
                  },
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field-group" }, [
          _c("div", { staticClass: "field-row" }, [
            _c("div", { staticClass: "field" }, [
              _c("label", { attrs: { for: _vm.side + "-from" } }, [
                _vm._v("Sampled from"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "date-input" },
                [
                  _c("v-text-field", {
                    attrs: {
                      id: _vm.side + "-from",
                      value: _vm.text.From,
                      placeholder: "Any date",
                      "hide-details": "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onTextInput("From", $event)
                      },
                      blur: function ($event) {
                        return _vm.commitDate("From")
                      },
                      keyup: [
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.commitDate("From")
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "esc", 27, $event.key, [
                              "Esc",
                              "Escape",
                            ])
                          )
                            return null
                          return _vm.syncText.apply(null, arguments)
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "close-on-content-click": false,
                        "offset-y": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  {
                                    staticClass: "date-input__picker",
                                    attrs: { icon: "", small: "" },
                                  },
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v("date_range"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.dateMenu.From,
                        callback: function ($$v) {
                          _vm.$set(_vm.dateMenu, "From", $$v)
                        },
                        expression: "dateMenu.From",
                      },
                    },
                    [
                      _vm._v(" "),
                      _c("v-date-picker", {
                        attrs: { value: _vm.dateValue("From"), "no-title": "" },
                        on: {
                          input: function ($event) {
                            return _vm.pickDate("From", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field" }, [
              _c("label", { attrs: { for: _vm.side + "-to" } }, [
                _vm._v("Sampled to"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "date-input" },
                [
                  _c("v-text-field", {
                    attrs: {
                      id: _vm.side + "-to",
                      value: _vm.text.To,
                      placeholder: "Any date",
                      "hide-details": "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onTextInput("To", $event)
                      },
                      blur: function ($event) {
                        return _vm.commitDate("To")
                      },
                      keyup: [
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.commitDate("To")
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "esc", 27, $event.key, [
                              "Esc",
                              "Escape",
                            ])
                          )
                            return null
                          return _vm.syncText.apply(null, arguments)
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "close-on-content-click": false,
                        "offset-y": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  {
                                    staticClass: "date-input__picker",
                                    attrs: { icon: "", small: "" },
                                  },
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v("date_range"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.dateMenu.To,
                        callback: function ($$v) {
                          _vm.$set(_vm.dateMenu, "To", $$v)
                        },
                        expression: "dateMenu.To",
                      },
                    },
                    [
                      _vm._v(" "),
                      _c("v-date-picker", {
                        attrs: { value: _vm.dateValue("To"), "no-title": "" },
                        on: {
                          input: function ($event) {
                            return _vm.pickDate("To", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "date-shortcuts" },
            [
              _c(
                "v-menu",
                {
                  attrs: { "offset-y": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on }) {
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              {
                                staticClass: "date-shortcuts__btn",
                                attrs: { flat: "", small: "" },
                              },
                              on
                            ),
                            [
                              _c("v-icon", { attrs: { left: "", small: "" } }, [
                                _vm._v("calendar_today"),
                              ]),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.rangeLabel) +
                                  "\n              "
                              ),
                              _c(
                                "v-icon",
                                { attrs: { right: "", small: "" } },
                                [_vm._v("arrow_drop_down")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    _vm._l(_vm.shortcuts, function (shortcut) {
                      return _c(
                        "v-list-tile",
                        {
                          key: shortcut.key,
                          on: {
                            click: function ($event) {
                              return _vm.applyShortcut(shortcut)
                            },
                          },
                        },
                        [
                          _c("v-list-tile-title", [
                            _vm._v(_vm._s(shortcut.name())),
                          ]),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.hasRange
                ? _c(
                    "v-btn",
                    {
                      staticClass: "date-shortcuts__clear",
                      attrs: { flat: "", small: "" },
                      on: { click: _vm.clearDates },
                    },
                    [
                      _c("v-icon", { attrs: { left: "", small: "" } }, [
                        _vm._v("clear"),
                      ]),
                      _vm._v("\n          Clear\n        "),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "field-row" }, [
            _c(
              "div",
              { staticClass: "field" },
              [
                _c("label", { attrs: { for: _vm.side + "-time-from" } }, [
                  _vm._v("Time from"),
                ]),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: {
                    id: _vm.side + "-time-from",
                    value: _vm.text.TimeFrom,
                    type: "time",
                    placeholder: "Any time",
                    "hide-details": "",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.onTextInput("TimeFrom", $event)
                    },
                    blur: function ($event) {
                      return _vm.commitTime("TimeFrom")
                    },
                    keyup: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.commitTime("TimeFrom")
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "esc", 27, $event.key, [
                            "Esc",
                            "Escape",
                          ])
                        )
                          return null
                        return _vm.syncText.apply(null, arguments)
                      },
                    ],
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "field" },
              [
                _c("label", { attrs: { for: _vm.side + "-time-to" } }, [
                  _vm._v("Time to"),
                ]),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: {
                    id: _vm.side + "-time-to",
                    value: _vm.text.TimeTo,
                    type: "time",
                    placeholder: "Any time",
                    "hide-details": "",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.onTextInput("TimeTo", $event)
                    },
                    blur: function ($event) {
                      return _vm.commitTime("TimeTo")
                    },
                    keyup: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.commitTime("TimeTo")
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "esc", 27, $event.key, [
                            "Esc",
                            "Escape",
                          ])
                        )
                          return null
                        return _vm.syncText.apply(null, arguments)
                      },
                    ],
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.timeInverted
            ? _c("p", { staticClass: "field-note field-note--warn" }, [
                _vm._v(
                  "\n        Time from is later than time to, so no sample on any day can match. Widen the window or\n        clear one end.\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("p", { staticClass: "field-note" }, [
            _vm._v(
              "\n        Both dates are inclusive of the whole day, and the time window applies to every day in\n        the range. Type a date as YYYY-MM-DD or pick it from the calendar.\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "field" },
            [
              _c("label", { attrs: { for: _vm.side + "-alias" } }, [
                _vm._v("QA/QC alias"),
              ]),
              _vm._v(" "),
              _vm.aliasCollisionNote
                ? _c("p", { staticClass: "field-note field-note--warn" }, [
                    _vm._v(_vm._s(_vm.aliasCollisionNote)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("v-select", {
                attrs: {
                  id: _vm.side + "-alias",
                  value: _vm.filter.AliasLabels,
                  items: _vm.aliases,
                  "item-text": "label",
                  "item-value": "id",
                  multiple: "",
                  chips: "",
                  "deletable-chips": "",
                  "small-chips": "",
                  placeholder: "Any alias",
                  "hide-details": "",
                },
                on: {
                  input: function ($event) {
                    return _vm.set("AliasLabels", $event)
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(0),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field-group" }, [
          _c(
            "div",
            { staticClass: "field" },
            [
              _c("label", { attrs: { for: _vm.side + "-media" } }, [
                _vm._v("Media type"),
              ]),
              _vm._v(" "),
              _c("v-select", {
                attrs: {
                  id: _vm.side + "-media",
                  value: _vm.filter.MediaTypes,
                  items: _vm.mediaTypes,
                  "item-text": "label",
                  "item-value": "id",
                  multiple: "",
                  chips: "",
                  "deletable-chips": "",
                  "small-chips": "",
                  placeholder: "Any media type",
                  "hide-details": "",
                },
                on: {
                  input: function ($event) {
                    return _vm.set("MediaTypes", $event)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "field-note" }, [
            _vm._v(
              "\n        The two sides must share at least one media type. Analytes are matched on\n        analyte + fraction.\n      "
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "field-note" }, [
      _vm._v("\n          A sample matching "),
      _c("em", [_vm._v("any")]),
      _vm._v(
        " selected alias is kept. Each extra value widens this\n          side's match set.\n        "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }